"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Productdetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var Productdetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Productdetail, _super);
    function Productdetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '自有积分商品详情接口';
        _this.code = '101105';
        _this.desc = '自有积分商品详情接口';
        _this.requestParams = new point_1.ProductdetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Productdetail;
}(service_1.BaseService));
exports.Productdetail = Productdetail;
//# sourceMappingURL=productdetail.js.map